import PageHeader from "@/components/PageHeader";
import ProcessFlow from "@/components/ProcessFlow";

export default function ProcessPage() {
  return (
    <>
      <PageHeader
        eyebrow="Notre process"
        title="De votre demande à la pièce finie."
        sub="Cinq étapes claires : devis sur mesure, validation par PDF (rendu 3D et/ou plan), paiement — acompte de 30 % au-delà de 50 € — puis livraison des fichiers ou de la pièce imprimée."
        pageTitle="Notre process — De la demande à l'impression 3D | TroiDéo"
      />
      <ProcessFlow />
    </>
  );
}
